<template>
  <div class="trigger trigger-border">
    <label>{{ $t('configuracao-dos-gatilhos-de-media') }}</label>

    <!-- Primeira linha (VMD, VMT, AMH) -->
    <span class="flex-row justify-around">
      <!-- VMD -->
      <div class="trigger-border">
        <span :title="triggerInfo.VMD.title" class="element-overlap">
          <b-form-checkbox id="checkbox-10" v-model="vmdActive" @change="sendVMD" class="trigger-checkBox"
            name="checkbox-10" value="true">
            {{ $t('dias-sem-media-atingir-meta') }} </b-form-checkbox>
          <b-icon v-if="!show" @click="() => showInfo(triggerInfo.VMD.description)" class="question-icon"
            icon="question-circle-fill" aria-hidden="true">
          </b-icon>
          <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary', content: this.$t('explicacao-fca-9'), }"
            class="question-icon" icon="question-circle-fill" aria-hidden="true">
          </b-icon>
        </span>
        <div class="flex-row justify-around width350 trigger-box">
          <label for="minute-interval">{{ $t('nao-conformidades') }}</label>
          <b-form-input type="number" size="sm" v-model="vmdUnconformities" @keyup="sendVMD" @change="sendVMD"
            id="minute-interval" placeholder="1" min="1" @input="handleInput('vmdUnconformities', $event)">
          </b-form-input>
        </div>
      </div>

      <!-- VMT -->
      <div v-if="!isRta" class="trigger-border pb-3">
        <span :title="triggerInfo.VMT.title" class="element-overlap">
          <b-form-checkbox id="checkbox-11" v-model="vmtActive" @change="sendVMT" class="trigger-checkBox"
            name="checkbox-11" value="true">
            {{ $t('dias-sem-media-atingir-meta-do-turno') }}
          </b-form-checkbox>
          <b-icon v-if="!show" @click="() => showInfo(triggerInfo.VMT.description)" class="question-icon"
            icon="question-circle-fill" aria-hidden="true">
          </b-icon>
          <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary', content: this.$t('explicacao-fca-10'), }"
            class="question-icon" icon="question-circle-fill" aria-hidden="true">
          </b-icon>
        </span>
        <div class="flex-row justify-around trigger-box">
          <label for="minute-interval">{{ $t('nao-conformidades') }}</label>
          <b-form-input type="number" size="sm" v-model="vmtUnconformities" @keyup="sendVMT" @change="sendVMT"
            id="minute-interval" placeholder="1" min="1" @input="handleInput('vmtUnconformities', $event)">
          </b-form-input>
        </div>
      </div>

      <div v-if="!isRta" class="trigger-border pb-3">
        <span :title="triggerInfo.AMH.title" class="element-overlap">
          <b-form-checkbox id="checkbox-12" v-model="amhActive" @change="sendAMH" class="trigger-checkBox"
            name="checkbox-12" value="true">
            {{ $t('media-de-aderencia-horaria-fora-da-meta') }} </b-form-checkbox>
          <b-icon v-if="!show" @click="() => showInfo(triggerInfo.AMH.description)" class="question-icon"
            icon="question-circle-fill" aria-hidden="true">
          </b-icon>
          <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary', content: this.$t('explicacao-fca-11'), }"
            class="question-icon" icon="question-circle-fill" aria-hidden="true">
          </b-icon>
        </span>
        <div class="flex-row justify-around trigger-box">
          <span class="flex-row justify-around width210">
            <label for="minute-interval">{{ $t('intervalo') }}</label>
            <b-form-input type="number" size="sm" id="minute-interval" v-model="minutes" @keyup="this.sendAMH"
              @change="this.sendAMH" placeholder="1" @input="handleInput('minutes', $event)" min="1"></b-form-input>
            <label v-if="show" for="minute-interval">{{ $t('days') }}</label>
            <label v-if="!show" for="minute-interval">{{ $t('minutos') }}</label>
          </span>
        </div>
      </div>

    </span>

    <span v-if="!isRta" class="flex-row mt-3 justify-around">
      <div class="trigger-border p-3">
        <span :title="triggerInfo.VMH.title" class="element-overlap">
          <b-form-checkbox id="checkbox-13" v-model="vmhActive" @change="sendVMH" class="trigger-checkBox"
            name="checkbox-13" value="true">
            {{ $t('tempo-sem-atingir-a-media-de-valor-do-indicador') }}
          </b-form-checkbox>
          <b-icon @click="() => showInfo(triggerInfo.VMH.description)" class="question-icon" icon="question-circle-fill"
            aria-hidden="true"/>
        </span>

        <div class="flex-row justify-between trigger-box align-items-center" style="gap: 1rem;">
          <!-- Intervalo (Só no VMH) -->
          <span class="flex-row align-items-center" style="gap: 1px;">
            <label for="vmh-minutes">{{ $t('intervalo-min') }}</label>
            <b-form-input type="number" size="sm" id="vmh-minutes" v-model="vmhMinutes" @keyup="sendVMH"
              @change="sendVMH" placeholder="60" style="width: 70px;" min="1"/>
          </span>

          <span class="flex-row align-items-center" style="gap: 1px;">
            <b-form-checkbox name="vmh-min-checkbox" v-model="vmhMinActive" @change="sendVMH" class="trigger-checkBox"
              value=true></b-form-checkbox>
            <label for="vmh-min">{{ $t('limite-minimo') }}</label>
            <b-form-input type="number" size="sm" id="vmh-min" v-model="vmhMinValue" @keyup="sendVMH" @change="sendVMH"
              placeholder="0" style="width: 80px; margin-left: 4px;" :disabled="!vmhMinActive" />
          </span>

          <span class="flex-row align-items-center" style="gap: 1px;">
            <b-form-checkbox name="vmh-max-checkbox" v-model="vmhMaxActive" @change="sendVMH" class="trigger-checkBox"
              value=true></b-form-checkbox>
            <label for="vmh-max">{{ $t('limite-maximo') }}</label>
            <b-form-input type="number" size="sm" id="vmh-max" v-model="vmhMaxValue" @keyup="sendVMH" @change="sendVMH"
              placeholder="9999" style="width: 75px; margin-left: 4px;" :disabled="!vmhMaxActive" />
          </span>
        </div>
      </div>

      <div class="trigger-border p-3">
        <span :title="triggerInfo.VMW.title" class="element-overlap">
          <b-form-checkbox id="checkbox-14" v-model="vmwActive" @change="sendVMW" class="trigger-checkBox"
            name="checkbox-14" value="true">
            {{ $t('media-do-turno-fora-do-limite') }}
          </b-form-checkbox>
          <b-icon @click="() => showInfo(triggerInfo.VMW.description)" class="question-icon" icon="question-circle-fill"
            aria-hidden="true" />
        </span>

        <div class="flex-row justify-between trigger-box align-items-center" style="gap: 1rem;">
          <!-- Limite Mínimo -->
          <span class="flex-row align-items-center" style="gap: 1px;">
            <b-form-checkbox name="vmw-min-checkbox" v-model="vmwMinActive" @change="sendVMW" class="trigger-checkBox"
              value=true></b-form-checkbox>
            <label style="white-space: nowrap; text-wrap: nowrap;" for="vmw-min">{{ $t('limite-minimo') }}</label>
            <b-form-input type="number" size="sm" id="vmw-min" v-model="vmwMinValue" @keyup="sendVMW" @change="sendVMW"
              placeholder="0" style="width: 80px; margin-left: 4px;" :disabled="!vmwMinActive" />
          </span>

          <span class="flex-row align-items-center" style="gap: 1px;">
            <b-form-checkbox name="vmw-max-checkbox" v-model="vmwMaxActive" @change="sendVMW" class="trigger-checkBox"
              value=true></b-form-checkbox>
            <label style="white-space: nowrap; text-wrap: nowrap;" for="vmw-max">{{ $t('limite-maximo') }}</label>
            <b-form-input type="number" size="sm" id="vmw-max" v-model="vmwMaxValue" @keyup="sendVMW" @change="sendVMW"
              placeholder="9999" style="width: 80px; margin-left: 4px;" :disabled="!vmwMaxActive" />
          </span>
        </div>
      </div>
    </span>

  </div>
</template>

<script>
import MediatorTrigger from "../tools/MediatorTrigger"

export default {
  name: "TriggerAverageValue",
  props: ["triggerInfo", "reset", "triggerSelected", "show", "isRta"],
  inject: ["showInfo", "showResponsibles"],
  data() {
    return {
      vmdActive: false,
      vmdUnconformities: 1,

      vmtActive: false,
      vmtUnconformities: 1,

      amhActive: false,
      minutes: 60,
      daysConverted: 0,

      vmhActive: false,
      vmhMinValue: 0,
      vmhMaxValue: 9999,
      vmhMinutes: 60,
      vmhMinActive: false,
      vmhMaxActive: false,

      vmwActive: false,
      vmwMinValue: 0,
      vmwMaxValue: 9999,
      vmwMinActive: false,
      vmwMaxActive: false,


    }
  },

  watch: {
    reset() {
      this.resetForm()
    },
  },

  methods: {
    loadForm(value) {
      if (!value.VMD) return
      this.loadData(value)
    },

    sendVMD() {
      MediatorTrigger.notify({
        active: this.vmdActive,
        unconformities: this.vmdUnconformities
      }, "setVMD")
    },

    sendVMT() {
      MediatorTrigger.notify({
        active: this.vmtActive,
        unconformities: this.vmtUnconformities
      }, "setVMT")
    },

    sendAMH() {
      if (this.show) {
        this.daysConverted = (this.minutes * 1440)

        MediatorTrigger.notify({
          active: this.amhActive,
          minutes: this.daysConverted
        }, "setAMH")
      } else {
        MediatorTrigger.notify({
          active: this.amhActive,
          minutes: this.minutes
        }, "setAMH")
      }
    },

    sendVMH() {
      if (this.show) {
        this.daysConverted = (this.vmhMinutes * 1440);
        MediatorTrigger.notify({
          active: this.vmhActive,
          minValue: this.vmhMinValue,
          maxValue: this.vmhMaxValue,
          minutes: this.daysConverted,
          minActive: this.vmhMinActive,
          maxActive: this.vmhMaxActive
        }, "setVMH")
      } else {
        MediatorTrigger.notify({
          active: this.vmhActive,
          minValue: this.vmhMinValue,
          maxValue: this.vmhMaxValue,
          minutes: this.vmhMinutes,
          minActive: this.vmhMinActive,
          maxActive: this.vmhMaxActive
        }, "setVMH")
      }
    },

    sendVMW() {
      MediatorTrigger.notify({
        active: this.vmwActive,
        minValue: this.vmwMinValue,
        maxValue: this.vmwMaxValue,
        minActive: this.vmwMinActive,
        maxActive: this.vmwMaxActive
      }, "setVMW");
    },



    async loadData(value) {
      await this.resetForm()
      this.vmdActive = value.VMD.active;
      if (value.VMD.configurationJSON) {
        let configurationJSON = JSON.parse(value.VMD.configurationJSON)
        this.vmdUnconformities = configurationJSON.unconformities;
      }

      this.vmtActive = value.VMT.active;
      if (value.VMT.configurationJSON) {
        let configurationJSON = JSON.parse(value.VMT.configurationJSON)
        this.vmtUnconformities = configurationJSON.unconformities;
      }

      this.amhActive = value.AMH.active;
      if (value.AMH.configurationJSON) {
        let configurationJSON = JSON.parse(value.AMH.configurationJSON)
        if (this.show) {
          this.minutes = configurationJSON.minutes / 1440;
        } else {
          this.minutes = configurationJSON.minutes;
        }
      }

      this.vmhActive = value.VMH.active;
      if (value.VMH.configurationJSON) {
        let configurationJSON = JSON.parse(value.VMH.configurationJSON)
        this.vmhMinValue = configurationJSON.minValue;
        this.vmhMaxValue = configurationJSON.maxValue;
        this.vmhMinActive = configurationJSON.minActive;
        this.vmhMaxActive = configurationJSON.maxActive;
        if (this.show) {
          this.vmhMinutes = configurationJSON.minutes / 1440;
        } else {
          this.vmhMinutes = configurationJSON.minutes;
        }
      }

      this.vmwActive = value.VMW.active;
      if (value.VMW.configurationJSON) {
        let configurationJSON = JSON.parse(value.VMW.configurationJSON)
        this.vmwMinValue = configurationJSON.minValue;
        this.vmwMaxValue = configurationJSON.maxValue;
        this.vmwMinActive = configurationJSON.minActive;
        this.vmwMaxActive = configurationJSON.maxActive;
      }
    },

    resetForm() {
      this.vmdActive = false;
      this.vmdUnconformities = 1;
      this.vmtActive = false;
      this.vmtUnconformities = 1;
      this.amhActive = false;

      if (this.show) {
        this.minutes = 1;
        this.vmhMinutes = 1;
      } else {
        this.minutes = 60;
        this.vmhMinutes = 60;
      }

      this.daysConverted = 0;
      this.vmhActive = false;
      this.vmhMinValue = 0;
      this.vmhMaxValue = 60;
      this.vmhMinActive = false;
      this.vmhMaxActive = false;

      this.vmwActive = false;
      this.vmwMinValue = 0;
      this.vmwMaxValue = 60;
      this.vmwMinActive = false;
      this.vmwMaxActive = false;
    },

    handleInput(prop, event) {
      let cleanedValue = event.replace(/\D/g, '');
      if (prop == 'vmdUnconformities')
        this.vmdUnconformities = cleanedValue !== '' ? parseInt(cleanedValue) : null;
      else if (prop == 'vmtUnconformities')
        this.vmtUnconformities = cleanedValue !== '' ? parseInt(cleanedValue) : null;
      else{
        this.minutes = cleanedValue !== '' ? parseInt(cleanedValue) : null;
        this.vmhMinutes = cleanedValue !== '' ? parseInt(cleanedValue) : null;
      }
    }
  },

  mounted() {
    console.log("TriggerAverageValue - isRta:", this.isRta);
    if (this.show) {
      this.minutes = 1;
      this.vmhMinutes = 1;

    }

    MediatorTrigger.notify(this, "initTriggerAverageValue")
  }
}
</script>

<style scoped src="../style.css"></style>